import React from "react";

const DeleteInviteModal = ({ deleteMethod, id, fullName, entity }) => {
  return (
    <div className="modal fade" id={`delete-invite-modal-${id}`} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div>
            <h4 className="text-center mb-4">{entity} will be deleted </h4>
            <p className="text-center text-small">
              {entity} <strong>{fullName}</strong> will be deleted.
              <br />
              Please confirm your action, as it cannot be undone.
            </p>

            <div className="text-center mt-4">
              <button
                type="button"
                className="btn btn-main"
                data-dismiss="modal"
                onClick={() =>
                  deleteMethod.mutate({
                    id: id,
                  })
                }
              >
                Delete
              </button>
              <button
                type="button"
                className="btn btn-sm btn-cancel"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DeleteInviteModal.propTypes = {};

export default DeleteInviteModal;
